import {Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ILSMDontShow, ILSModalButton} from '@shared/ledger-sync-modal/interface';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {LedgerSyncModalService} from '@shared/ledger-sync-modal/service.service';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {ButtonComponent} from '../../controls/button/button.component';

@Component({
  selector: 'app-ledger-sync-modal',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule, FormsModule, YouTubePlayerModule, ButtonComponent],
  templateUrl: './ledger-sync-modal.component.html',
  styleUrls: ['./ledger-sync-modal.component.scss']
})
export class LedgerSyncModalComponent {
  dsValue: boolean;
  footer: boolean;
  header: string;
  headerAlign: 'start' | 'end' | 'center' = 'start';
  message: string;
  videoId: string;
  html: string;
  dontShow: ILSMDontShow = {} as ILSMDontShow;
  buttons: ILSModalButton[];

  constructor(
    private ledgerSyncModalService: LedgerSyncModalService,
    public modalRef: BsModalRef,
  ) {
  }

  close() {
    this.modalRef.hide();
  }

  updateDontShow() {
    this.ledgerSyncModalService.updateDontShow({...this.dontShow, dontShowAgain: this.dsValue});
  }
}
